import(/* webpackMode: "eager" */ "/vercel/path0/apps/platform/common/components/Navbar/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/apps/platform/common/components/Toasts/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
